import ro from "./images/ro.jpg";
import ro1 from "./images/ro1.jpg";
import ro2 from "./images/ro2.jpg";
import clean1 from "./images/clean1.jpg"
import clean2 from "./images/clean2.jpg"
import clean3 from "./images/clean3.jpg"
import clean4 from "./images/clean4.jpg"
import clean5 from "./images/clean5.jpg"
import clean6 from "./images/clean6.jpg"
import gym1 from "./images/gym1.jpg";
import gym2 from "./images/gym2.jpg";
import gym3 from "./images/gym3.jpg";
import gym4 from "./images/gym4.jpg";
import gym5 from "./images/gym5.jpg";
import gym6 from "./images/gym6.jpg";
import gym7 from "./images/gym7.png";
import gym8 from "./images/gym8.jpg";
import gym9 from "./images/gym9.png";
import furni1 from "./images/furni1.webp";
import furni2 from "./images/furni2.jpg";
import furni3 from "./images/furni3.jpg";
import furni4 from "./images/furni4.jpg";
import digi1 from "./images/digi1.jpg";
import digi2 from "./images/digi2.jpg";
import digi3 from "./images/digi3.jpg";
import stat1 from "./images/stationary1.jpg";
import stat2 from "./images/stationary4.png";
import stat3 from "./images/stationary3.jpg";
import light2 from "./images/light2.jpg";
import light3 from "./images/light3.jpg";
import light4 from "./images/light4.jpg";
import light5 from "./images/light5.jpg";
import img1 from "./images/treatment.jpg";
import img2 from "./images/cleaning-1.jpg";
import img3 from "./images/gym.jpg";
import img4 from "./images/school-furniture.jpg";
import img5 from "./images/digital-school.jpg";
import img6 from "./images/stationary.jpg";
import img7 from "./images/street-light.jpg";

export default [
  {
    sys: {
      id: "1"
    },
    fields: {
      name: "water treatment",
      slug: "water-treatment",
      type: "water treatment",
      price: 3000,
      size: 200,
      capacity: "unlimited",
      // pets: false,
      // breakfast: false,
      featured: true,
      description:
        "From reverse osmosis products to antifoams, chlorine dioxide solutions to dipslides, we supply speciality chemical products here in the India. We formulate a wide range of water treatment products in our modern Nagpur and Akola facility for a number of applications, including:",
      extras: [
        "UV technology based water purifier",
        "Double purification by UV + UF makes water 100% pure",
        "High purification capacity",
        "Disinfects water without changing its taste, odour and pH scale",
        "Filter change and UV light change facility",
        "Best suited for low TDS water and high industrial water",
        "Comfortable oprations"
      ],
      images: [
        {
          fields: {
            file: {
              url: img1
            }
          }
        },
        {
          fields: {
            file: {
              url: ro
            }
          }
        },
        {
          fields: {
            file: {
              url: ro1
            }
          }
        },
        {
          fields: {
            file: {
              url: ro2
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "2"
    },
    fields: {
      name: "cleaning & sanitation",
      slug: "cleaning-sanitation",
      type: "cleaning & sanitation",
      price: 150,
      size: 250,
      capacity: "unlimited",
      // pets: false,
      // breakfast: false,
      featured: true,
      description:
      "Om Traders has one clear objective as it relates to sustainable cleaning: to enhance environmental health and workplace safety. This has been our core philosophy for many years. We recognize that cleaning products and practices have a direct impact on quality of life. That is why we strive to be good stewards when maintaining facilities. Our services are about “caring” for a building and going far beyond providing basic janitorial services.",
      extras: [
        "Housekeeping Services",
        "Guest House Management Services",
        "Pest Control Services",
        "Façade Cleaning Services",
        "Mailroom Services",
        "Hand Sanitizers"
      ],
      images: [
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: clean1
            }
          }
        },
        {
          fields: {
            file: {
              url: clean2
            }
          }
        },
        {
          fields: {
            file: {
              url: clean3
            }
          }
        },
        {
          fields: {
            file: {
              url: clean4
            }
          }
        },
        {
          fields: {
            file: {
              url: clean5
            }
          }
        },
        {
          fields: {
            file: {
              url: clean6
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "3"
    },
    fields: {
      name: "green gym",
      slug: "green-gym",
      type: "green gym",
      price: 15000,
      size: 300,
      capacity: "1-5",
      // pets: true,
      // breakfast: false,
      featured: true,
      description:
        "We offer specially designed outdoor gym equipment for those fitness enthusiasts who like to stay close to nature. An outdoor gym allows people to work out in the open with ample fresh air as compared to indoor gyms.",
      extras: [
        "Mild Steel, GI",
        "Outdoor Use",
        "Non Portable",
        "Customised",
      ],
      images: [
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: gym1
            }
          }
        },
        {
          fields: {
            file: {
              url: gym2
            }
          }
        },
        {
          fields: {
            file: {
              url: gym3
            }
          }
        },
        {
          fields: {
            file: {
              url: gym4
            }
          }
        },
        {
          fields: {
            file: {
              url: gym5
            }
          }
        },
        {
          fields: {
            file: {
              url: gym6
            }
          }
        }
        ,
        {
          fields: {
            file: {
              url: gym7
            }
          }
        }
        ,
        {
          fields: {
            file: {
              url: gym8
            }
          }
        }
        ,
        {
          fields: {
            file: {
              url: gym9
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "4"
    },
    fields: {
      name: "school furniture",
      slug: "school-furniture",
      type: "school furniture",
      price: 3000,
      size: 400,
      capacity: "1-3",
      // pets: true,
      // breakfast: true,
      featured: false,
      description:
        "We are having most excellent team of professionals, who are highly betrothed in presenting huge collection series of School Furniture, which is developed using the advanced techniques and top quality raw material. Our products are available in diverse design and sizes. Along with this, this product is available to customers within preset time period.",
      extras: [
        "Easy to use",
        "Low maintenance",
        "Precise sizes",
        "Sizes as per client requirement",
        "Customized product also available",
      ],
      images: [
        {
          fields: {
            file: {
              url: img4
            }
          }
        },
        {
          fields: {
            file: {
              url: furni1
            }
          }
        },
        {
          fields: {
            file: {
              url: furni2
            }
          }
        },
        {
          fields: {
            file: {
              url: furni3
            }
          }
        },
        {
          fields: {
            file: {
              url: furni4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "5"
    },
    fields: {
      name: "digital school",
      slug: "digital-school",
      type: "digital school",
      price: 5000,
      size: 300,
      capacity: "0-100",
      // pets: false,
      // breakfast: false,
      featured: true,
      description:
        "In an effort to enhance the power of collaborative learning with the widescreen, the integrated system combines an interactive whiteboard with an ultra-short-throw projector that virtually eliminates shadows and glare, a multiuser Pen Tray and a control panel that enables teachers to manage all classroom technology products from the front of the classroom. All projectors are backed by SMART Projector Care Plus program.",
      extras: [
        "Comprehensive solutions designed to assist teachers",
        "Instant access to multimedia content and instruction materials",
        "Ensure that every child in the class is learning",
        "Highly efficient in maintaining student’s interest and engagement in learning",
        "Easy-to-use interfaces",
      ],
      images: [
        {
          fields: {
            file: {
              url: img5
            }
          }
        },
        {
          fields: {
            file: {
              url: digi1
            }
          }
        },
        {
          fields: {
            file: {
              url: digi2
            }
          }
        },
        {
          fields: {
            file: {
              url: digi3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "6"
    },
    fields: {
      name: "stationary",
      slug: "stationary",
      type: "stationary",
      price: 250,
      size: 350,
      capacity: "unlimited",
      // pets: false,
      // breakfast: false,
      featured: false,
      description:
        "We are a unique name in the industry to provide our precious clients an exclusive range of Stationery Products. Procured from the authorized vendors, offered product is designed using premium grade basic material and advanced techniques. Owing to its smooth writing and attractive look, the provided product is widely demanded among our precious clients. Further, in order to ensure the flawlessness, this product is strictly tested by our quality controllers on various quality parameters.",
      extras: [
        "A4 Paper",
        "Notebooks, Accounts book, registers, leadger",
        "Stapler, stapler pin, punch, drawing pin, jump clip, paper clips, binder clips",
        "All kinds of files and folders",
        "Diary, Notepads, Spiral Pads, sticky notes, Receipt books",
        "Pen,Pencils, Markers, inks, Ink pads, refils",
        "Glue, fevikwik, flexkwik, Packing tape, cellotape, double side tape",
        "Chart papers, Drawing sheets",
        "Envelopes, covers , courier cover of all sizes"
      ],
      images: [
        {
          fields: {
            file: {
              url: img6
            }
          }
        },
        {
          fields: {
            file: {
              url: stat1
            }
          }
        },
        {
          fields: {
            file: {
              url: stat2
            }
          }
        },
        {
          fields: {
            file: {
              url: stat3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "7"
    },
    fields: {
      name: "street lights",
      slug: "street-lights",
      type: "street lights",
      price: 300,
      size: 400,
      capacity: "unlimited",
      // pets: true,
      // breakfast: false,
      featured: false,
      description:
        "We are counted among the leading names, actively functioning as Importer and trader of Solar Street Lights in Maharashtra, India. Solar Street Lights that we bring forth are fully automatic and come with a warranty of one year. The entire array is designed and constructed using the best grade material and advanced production techniques. Our Solar Street Lights are known for their operation fluency and longevity and available at feasible prices.",
      extras: [
        "the LED’s can go up to 50,000 hours",
        "the batteries can last 2-5 years and cost only 15% of the value to replace",
        "The sensor automatically turns the unit ON in dark hours and switches it OFF during the morning eliminating the need for manual monitoring or controls",
        "Low maintainance",
        "High Quality material",
      ],
      images: [
        {
          fields: {
            file: {
              url: img7
            }
          }
        },
        {
          fields: {
            file: {
              url: light2
            }
          }
        },
        {
          fields: {
            file: {
              url: light3
            }
          }
        },
        {
          fields: {
            file: {
              url: light4
            }
          }
        },
        {
          fields: {
            file: {
              url: light5
            }
          }
        }
      ]
    }
  }
];
